import React from "react"

import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"

import { RiArrowRightSLine } from "react-icons/ri"
import { Container, Row, Col } from "react-bootstrap"
import Accordion from "react-bootstrap/Accordion"
import Button from "react-bootstrap/Button"
import Card from "react-bootstrap/Card"
import styled from "@emotion/styled"

import { css } from "@emotion/core"

import Layout from "../components/layout"
import SEO from "../components/seo"
import SakuraText from "../components/sakura-text"

const PaddedBotDiv = styled("div")`
  padding-bottom: 30px;
`

const PinkSpan = styled("span")`
  color: #ff2ea0;
`

const PlanTitle = ({ txt }) => {
  return (
    <h3
      css={css`
        color: #5f4235;
      `}
    >
      <strong>{txt}</strong>
    </h3>
  )
}

const PinkTable = ({ children }) => {
  return (
    <table
      css={css`
        border: 1px solid black;
        margin: 0 0 15px;
        text-align: left;
        width: 100%;
        th {
          border: 1px solid black;
          padding: 6px 24px 6px 24px;
          background-color: #fae8ef;
        }
        td {
          border: 1px solid black;
          padding: 6px 24px 6px 24px;
        }
      `}
    >
      {children}
    </table>
  )
}

const ThePage = () => {
  const data = useStaticQuery(graphql`
    query serviceQuery {
      banner: file(relativePath: { eq: "about-1-4-2.png" }) {
        childImageSharp {
          resize(width: 300) {
            src
          }
        }
      }
    }
  `)

  const padBotCss = css`
    padding-bottom: 30px;
  `

  const anchorCss = css`
    padding-top: 80px;
  `

  return (
    <Layout>
      <SEO
        title="葡萄糖素去甲醛費用 | 電、空氣、日本光觸媒除甲醛公司價錢收費"
        description="櫻花家居服務公司是除甲醛的最佳選擇，收費清晰、價錢合理。以葡萄糖素、空氣觸媒、電觸媒及日本光觸媒等有認證的日本技術除甲醛，除甲醛收費詳情請參閱本網。"
      />
      <div
        css={css`
          max-width: 1080px;
          margin: 0 auto;
          padding: 80px 0;
        `}
      >
        <Container className="home-banner">
          <Row className="justify-content-sm-center" css={padBotCss}>
            <Col css={padBotCss} sm={6} xs={12}>
              <div
                css={css`
                  color: #5f4235;
                `}
              >
                <h1>
                  <strong>櫻花除甲醛服務收費</strong>
                </h1>
                <h2>
                  <strong>4種技術 3款套餐</strong>
                </h2>
              </div>
              <div>
                櫻花家居知道香港每個室內環境均需不同層面的空氣淨化服務，所以，櫻花家居特意設計三種個人化的靈活套餐，融合四種除甲醛技術：空氣觸媒、葡萄糖素、日本光觸媒及電觸媒，以合理費用讓您自由地選擇適合你室內環境的淨化服務；不論您是想改善家居質素，或是想提升辦公室工作環境質素，櫻花目的是使用專業技術令您重新得到一個舒適居住和工作空間。
              </div>
            </Col>
            <Col css={padBotCss} sm={5} xs={12}>
              <img src={data.banner.childImageSharp.resize.src} />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <PaddedBotDiv>
                <h2
                  css={css`
                    text-align: center;
                  `}
                >
                  全新裝修🏗️
                </h2>
              </PaddedBotDiv>
            </Col>
          </Row>
          <Row css={padBotCss}>
            <Col css={padBotCss} md={6} xs={12}>
              <Accordion defaultActiveKey="-1">
                <Card>
                  <Accordion.Toggle
                    as={Card.Header}
                    css={css`
                      cursor: pointer;
                    `}
                    eventKey="0"
                  >
                    有嬰兒👶、孕婦或長者👵👴
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <a href="#planA">
                        <strong>
                          <span
                            css={css`
                              color: #ff2ea0;
                            `}
                          >
                            全方位套餐
                          </span>
                        </strong>
                      </a>
                      會用到我地🌸櫻花四種技術，成個套餐會做到分解同吸收甲醛作用，吸收甲醛用到嘅Grafton葡萄糖素係由🇯🇵日本直接進口，佢係一種甲醛捕捉劑，特別針對甲醛含量極多嘅板材裸木位置塗抹，從源頭封鎖並吸收甲醛，相比起高效套餐只用到三種分解原理嘅觸媒，會更加全面處理室內甲醛。
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Col>
            <Col css={padBotCss} md={6} xs={12}>
              <Accordion defaultActiveKey="-1">
                <Card>
                  <Accordion.Toggle
                    as={Card.Header}
                    css={css`
                      cursor: pointer;
                    `}
                    eventKey="0"
                  >
                    沒有嬰兒👶、孕婦或長者👵👴
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      會建議揀
                      <a href="#planB">
                        <strong>
                          <span
                            css={css`
                              color: #ff2ea0;
                            `}
                          >
                            中間高效套餐
                          </span>
                        </strong>
                      </a>
                      ，用到三種技術，基本上已經能夠處理到家居7-8成甲醛釋放。
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <PaddedBotDiv>
                <h2
                  css={css`
                    text-align: center;
                  `}
                >
                  局部裝修🏠
                </h2>
              </PaddedBotDiv>
            </Col>
          </Row>
          <Row css={padBotCss}>
            <Col css={padBotCss} md={6} xs={12}>
              <Accordion defaultActiveKey="-1">
                <Card>
                  <Accordion.Toggle
                    as={Card.Header}
                    css={css`
                      cursor: pointer;
                    `}
                    eventKey="0"
                  >
                    牆身有重新油油
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      牆身有重新油油，建議揀
                      <a href="#planB">
                        <strong>
                          <span
                            css={css`
                              color: #ff2ea0;
                            `}
                          >
                            中間高效套餐
                          </span>
                        </strong>
                      </a>
                      ，會用到日本東芝光觸媒，針對牆身、天花、窗簾，可見光位置。最好都影相俾我地睇下單位情況！
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Col>
            <Col css={padBotCss} md={6} xs={12}>
              <Accordion defaultActiveKey="-1">
                <Card>
                  <Accordion.Toggle
                    as={Card.Header}
                    css={css`
                      cursor: pointer;
                    `}
                    eventKey="0"
                  >
                    牆身沒有重新油油
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      如牆身無重新油油，我地會
                      <a href="#planC">
                        <strong>
                          <span
                            css={css`
                              color: #ff2ea0;
                            `}
                          >
                            度身訂造
                          </span>
                        </strong>
                      </a>
                      價錢俾你，最好影相俾我地睇下單位情況！
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <PaddedBotDiv>
                <h2
                  css={css`
                    text-align: center;
                  `}
                >
                  其他🛋️
                </h2>
              </PaddedBotDiv>
            </Col>
          </Row>
          <Row css={padBotCss}>
            <Col css={padBotCss} md={6} xs={12}>
              <Accordion defaultActiveKey="-1">
                <Card>
                  <Accordion.Toggle
                    as={Card.Header}
                    css={css`
                      cursor: pointer;
                    `}
                    eventKey="0"
                  >
                    買新傢俬
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      淨係買左新傢俬，我地會
                      <a href="#planC">
                        <strong>
                          <span
                            css={css`
                              color: #ff2ea0;
                            `}
                          >
                            度身訂造
                          </span>
                        </strong>
                      </a>
                      價錢俾你，建議影相俾我地睇你個新傢俬嘅材質同用料，咁可以針對性提供我地技術俾你
                      。
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Col>
            <Col css={padBotCss} md={6} xs={12}>
              <Accordion defaultActiveKey="-1">
                <Card>
                  <Accordion.Toggle
                    as={Card.Header}
                    css={css`
                      cursor: pointer;
                    `}
                    eventKey="0"
                  >
                    消毒
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <p>如果想進行全屋消毒，我們亦設有空間消毒服務。</p>
                      <p>
                        <Link
                          css={css`
                            color: #ff2ea0;
                          `}
                          to="/空間消毒服務"
                        >
                          <strong>按此了解</strong>
                        </Link>
                      </p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Col>
          </Row>
        </Container>
        <Container
          css={css`
            background-color: white;
            margin-bottom: 30px;
          `}
        >
          <Row
            css={css`
              padding-top: 30px;
            `}
          >
            <Col>
              <SakuraText text="櫻花除甲醛套餐內容及價錢" size={28} />
              <p>櫻花家居服務公司是您的除去甲醛最佳選擇，收費清晰、價錢合理。我們深明您的需要，因此提供一系列除甲醛服務方案，涵蓋不同技術，包括日本光觸媒、空氣觸媒、葡萄糖素及電觸媒，您可按預算以及空間大少選擇合適的套餐。除甲醛收費詳情請參閱以下內容：</p>
            </Col>
          </Row>
          <Row id="planA" css={[anchorCss]}>
            <Col css={padBotCss} md={6} xs={12}>
              <PlanTitle txt="全方位強效之選" />
              <p>使用技術：東芝光觸媒、電觸媒、空氣觸媒、葡萄糖素</p>
              <p>施工位置：窗簾、牆身、天花、傢俬、空間、木製傢俬隙縫</p>
              <p>施工時間：3小時（以600呎為例）</p>
            </Col>
            <Col css={padBotCss} md={6} xs={12}>
              <PinkTable>
                <thead>
                  <tr>
                    <th>全屋實用面積</th>
                    <th>服務收費</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>399 呎或以下</td>
                    <td>HKD 5,200</td>
                  </tr>
                  <tr>
                    <td>400呎 - 599 呎</td>
                    <td>HKD 6,400</td>
                  </tr>
                  <tr>
                    <td>600呎 - 799 呎</td>
                    <td>HKD 7,600</td>
                  </tr>
                  <tr>
                    <td>800呎 - 999 呎</td>
                    <td>HKD 8,600</td>
                  </tr>
                  <tr>
                    <td>1000呎 - 1299 呎</td>
                    <td>HKD 9,800</td>
                  </tr>
                  <tr>
                    <td>1300呎 - 1499 呎</td>
                    <td>HKD 11,400</td>
                  </tr>
                  <tr>
                    <td>1500呎或以上</td>
                    <td>另作報價</td>
                  </tr>
                </tbody>
              </PinkTable>
            </Col>
          </Row>
          <Row id="planB" css={[anchorCss]}>
            <Col css={padBotCss} md={6} xs={12}>
              <PlanTitle txt="高效安心之選" />
              <p>使用技術：東芝光觸媒、電觸媒、空氣觸媒</p>
              <p>施工位置：窗簾、牆身、天花、傢俬、空間</p>
              <p>施工時間：2.5小時（以600呎為例）</p>
            </Col>
            <Col css={padBotCss} md={6} xs={12}>
              <PinkTable>
                <thead>
                  <tr>
                    <th>全屋實用面積</th>
                    <th>服務收費</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>399 呎或以下</td>
                    <td>HKD 3,500</td>
                  </tr>
                  <tr>
                    <td>400呎 - 599 呎</td>
                    <td>HKD 4,100</td>
                  </tr>
                  <tr>
                    <td>600呎 - 799 呎</td>
                    <td>HKD 4,900</td>
                  </tr>
                  <tr>
                    <td>800呎 - 999 呎</td>
                    <td>HKD 5,500</td>
                  </tr>
                  <tr>
                    <td>1000呎 - 1299 呎</td>
                    <td>HKD 6,300</td>
                  </tr>
                  <tr>
                    <td>1300呎 - 1499 呎</td>
                    <td>HKD 7,100</td>
                  </tr>
                  <tr>
                    <td>1500呎或以上</td>
                    <td>另作報價</td>
                  </tr>
                </tbody>
              </PinkTable>
            </Col>
          </Row>
          <Row id="planC" css={[anchorCss]}>
            <Col css={padBotCss} md={6} xs={12}>
              <PlanTitle txt="經濟實惠之選" />
              <p>使用技術：電觸媒、空氣觸媒</p>
              <p>施工位置：傢俬、櫃內、空間源頭</p>
              <p>施工時間：2小時（以600呎為例）</p>
            </Col>
            <Col css={padBotCss} md={6} xs={12}>
              <PinkTable>
                <thead>
                  <tr>
                    <th>全屋實用面積</th>
                    <th>服務收費</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>399 呎或以下</td>
                    <td>HKD 2,800</td>
                  </tr>
                  <tr>
                    <td>400呎 - 599 呎</td>
                    <td>HKD 3,400</td>
                  </tr>
                  <tr>
                    <td>600呎 - 799 呎</td>
                    <td>HKD 4,000</td>
                  </tr>
                  <tr>
                    <td>800呎 - 999 呎</td>
                    <td>HKD 4,500</td>
                  </tr>
                  <tr>
                    <td>1000呎 - 1299 呎</td>
                    <td>HKD 5,100</td>
                  </tr>
                  <tr>
                    <td>1300呎 - 1499 呎</td>
                    <td>HKD 5,900</td>
                  </tr>
                  <tr>
                    <td>1500呎或以上</td>
                    <td>另作報價</td>
                  </tr>
                </tbody>
              </PinkTable>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <p>*不能噴塗的範圍：金屬、瓷磚、玻璃、雲石、鏡面及膠面。</p>
              <p>*部分偏遠地區須收車馬費，詳情請向櫻花家居查詢。</p>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col sm={6} xs={12}>
              <div
                css={css`
                  margin: 0 auto;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  padding-bottom: 30px;
                `}
              >
                <Link to="/booking" className="button">
                  <b>立即預約</b>
                  <span className="icon -right">
                    <RiArrowRightSLine />
                  </span>
                </Link>
              </div>
            </Col>
            <Col sm={6} xs={12}>
              <div
                css={css`
                  margin: 0 auto;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  padding-bottom: 30px;
                `}
              >
                <Link to="/櫻花除甲醛技術" className="button">
                  <b>了解櫻花技術</b>
                  <span className="icon -right">
                    <RiArrowRightSLine />
                  </span>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  )
}

export default ThePage
